import styled from 'styled-components/macro';

export const StyledButtonGroup = styled.div`
  display: inline-flex;
  align-items: center;

  & button {
    &:not(:first-of-type) {
      margin-left: -1px;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }

    &:not(:last-of-type) {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }

    &:hover,
    &:active,
    &[data-selected='true'] {
      z-index: 1;
    }
  }
`;
